import React from 'react'
import { Link } from 'react-router-dom'

function DashboardCard(props) {
  const urlLabelMapping = {
    Users: '/admin/users',
    Activities: '/admin/activities',
    Matches: '/admin/matches',
    Interests: '/admin/interests',
    Transactions: '/admin/orders',
  }

  return (
    // <div className="col-md-4">
    <div className="card shadow">
      <div
        className="card"
        style={{
          maxWidth: '600px',
          maxHeight: '300px',
          width: '100%',
          marginBottom: '0px',
          display: 'flex',
          height: '100px',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <div className="row no-gutters">
          <div className="col-md-8">
            <div
              className="card-body px-1 py-1"
              style={{
                display: 'flex',
              }}
            >
              <Link className="nav-link" to={urlLabelMapping[props.label]}>
                <h3 className="card-title">{props.label}</h3>
              </Link>
              <h4 className="card-text" style={{ margin: '0px', display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                {props.value}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    // </div>
  )
}

export { DashboardCard }
